import { useState, useEffect } from "react";
import "../styles/globals.css";
import Shell from "../components/layout/shell";
import { useRouter } from "next/router";
import Head from "next/head";
import {ThemeProvider} from 'next-themes';
import { LocaleProvider } from "../contexts/locale-context";

function MyApp({ Component, pageProps }) {
  const [isMounted, setIsMounted] = useState(false);

  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      setIsMounted(true);
    }
  }, [router.isReady]);

  if (!isMounted) return null;

  const getLayout = Component.isUnprotected
    ? (page) => <ThemeProvider><div className="h-[100dvh] pb-[calc(100dvh-100vh)]">{page}</div></ThemeProvider>
    : (page) => <Shell>{page}</Shell>;

  return (
    <LocaleProvider>
      <Head>
        <title>Workpeg</title>
        <link rel="manifest" href="/manifest.json" />
        <link rel="apple-touch-icon" href="/images/pwa-logo.svg"></link>
      </Head>
      {getLayout(<Component {...pageProps} />)}
    </LocaleProvider>
  );
}

export default MyApp;
